import MusicNoteIcon from "@mui/icons-material/MusicNote";
import HomeIcon from "@mui/icons-material/Home";
import CodeIcon from "@mui/icons-material/Code";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import SchoolIcon from "@mui/icons-material/School";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import { Title } from "@mui/icons-material";

export const logo = "https://i.ibb.co/s9Qys2j/logo.png";

export const categories = [
  // { name: "New", icon: <HomeIcon /> },
  // { name: "Frontend Development", icon: <CodeIcon /> },
  // { name: "MERN Stack", icon: <CodeIcon /> },
  // { name: "ReactJS", icon: <CodeIcon /> },
  // { name: "NextJS", icon: <CodeIcon /> },
  // { name: "Music", icon: <MusicNoteIcon /> },
  // { name: "Education", icon: <SchoolIcon /> },
  // { name: "Podcast", icon: <GraphicEqIcon /> },
  { name: "Movie", icon: <OndemandVideoIcon /> },
  // { name: "Gaming", icon: <SportsEsportsIcon /> },
  // { name: "Live", icon: <LiveTvIcon /> },
  // { name: "Sport", icon: <FitnessCenterIcon /> },
  // { name: "Fashion", icon: <CheckroomIcon /> },
  // { name: "Beauty", icon: <FaceRetouchingNaturalIcon /> },
  // { name: "Comedy", icon: <TheaterComedyIcon /> },
  { name: "Shows", icon: <TheaterComedyIcon /> },
  // { name: "Gym", icon: <FitnessCenterIcon /> },
  // { name: "Crypto", icon: <DeveloperModeIcon /> },
];

export const mediaLists = [
  {
    id: { videoId: "1" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E01" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e01.mp4",
  },
  {
    id: { videoId: "2" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E02" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e02.mp4",
  },
  {
    id: { videoId: "3" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E03" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e03.mp4",
  },
  {
    id: { videoId: "4" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E04" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e04.mp4",
  },
  {
    id: { videoId: "5" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E05" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e05.mp4",
  },
  {
    id: { videoId: "6" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E06" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e06.mp4",
  },
  {
    id: { videoId: "7" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E07" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e07.mp4",
  },
  {
    id: { videoId: "8" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E08" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e08.mp4",
  },
  {
    id: { videoId: "9" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E09" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e09.mp4",
  },
  {
    id: { videoId: "10" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E10" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e10.mp4",
  },
  {
    id: { videoId: "11" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E11" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e11.mp4",
  },
  {
    id: { videoId: "12" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E12" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e12.mp4",
  },
  {
    id: { videoId: "13" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E13" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e13.mp4",
  },
  {
    id: { videoId: "14" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E14" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e14.mp4",
  },
  {
    id: { videoId: "15" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E15" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e15.mp4",
  },
  {
    id: { videoId: "16" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E16" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e16.mp4",
  },
  {
    id: { videoId: "17" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E17" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e17.mp4",
  },
  {
    id: { videoId: "18" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E18" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e18.mp4",
  },
  {
    id: { videoId: "19" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E19" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e19.mp4",
  },
  {
    id: { videoId: "20" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E20" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e20.mp4",
  },
  {
    id: { videoId: "21" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E21" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e21.mp4",
  },
  {
    id: { videoId: "22" },
    snippet: { title: "Georgie and Mandy's First Marriage S01E22" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/shows/Georgie.and.Mandys.First.Marriage/Georgie.And.Mandys.First.Marriage.S01e22.mp4",
  },
  {
    id: { videoId: "23" },
    snippet: { title: "Madagascar 3 Europes Most Wanted" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/movies/Madagascar.3.Europes.Most.Wanted.mp4",
  },
  {
    id: { videoId: "24" },
    snippet: { title: "Oldboy" },
    url: "https://ps-video-storage.s3.us-east-2.amazonaws.com/movies/Oldboy.mp4",
  },
];

export const demoThumbnailUrl =
  "https://www.contentellect.com/wp-content/uploads/2022/02/broken-link-building-meme-768x511.jpg";
export const demoChannelUrl = "NA";
export const demoVideoUrl = "NA";
export const demoChannelTitle = "NA";
export const demoVideoTitle = "NA";
export const demoProfilePicture =
  "http://dergipark.org.tr/assets/app/images/buddy_sample.png";
